import React from "react";
import { Card } from "antd";
import HeaderComponent from "components/card/HeaderComponent";
import { Send, Users } from "lucide-react";

const AwardCategoryCard = (props) => {
  const {} = props;

  const categories = [
    {
      
    }
  ]
  return (
    <HeaderComponent
      title="Award Categories"
      titleClass="text-[16px] font-medium"
      description="Select an award category to nominate a team member"
      descriptionClass="text-sm"
      >
        <div className="grid grid-cols-1 md:grid-cols-3">
          <Card
            className="card-theme blue"
          >
            <div className="space-y-4">
                <div className="flex flex-col items-start justify-between gap-3">
                  <div className="icon-style p-3 text-white"><Users/></div>
                  <h4 class="card-text">Culture Hero</h4>
                  <p class="text-[13px] text-muted-foreground">Actively strengthens inclusion, respect, and team spirit.</p>
                </div>
                <button className="h-8 rounded-2xl w-full icon-style text-white inline-flex items-center justify-center font-semibold gap-3"><Send className="h-4 w-4" />Nominate</button>
            </div>
          </Card>
        </div>

    </HeaderComponent>

  );
};

export default AwardCategoryCard;
